import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { AuthService } from '../auth.service';
import { LanguageService } from '../language.service';

import { UserService } from '../api/user.service';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';

declare function require(name: string);
const CLIENT_VERSION = require('../../../../package.json').version;
const LIBRARY_VERSION = require('../../../../package.json').dependencies['ri-api-client']
  .replace('http://api.dev.revenueintelligence.net/ri-api-client/ri-api-client-', '')
  .replace('.tgz', '');

@Component({
  selector: 'ri-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  sidenavOpen: any;
  versions: any = {
    client: CLIENT_VERSION,
    library: LIBRARY_VERSION
  };

  constructor(
    private _localStorage: LocalStorageService,
    public _auth: AuthService,
    public languageService: LanguageService,
    private user: UserService,
    private apiService: ApiService,
    private router: Router
  ) {
    this.apiService.init();
  }

  ngOnInit() {
    this.sidenavOpen = this._localStorage.get('sidenavOpen');

    this.apiService.client.appVersion.GET().subscribe( response => {
      this.versions.api = response.bodyRaw.apiVersion;
      this.versions.db = response.bodyRaw.dbVersion;
    });
  }

  toggleSidenav(): void {
    this.sidenavOpen = !this.sidenavOpen;
    this._localStorage.set('sidenavOpen', this.sidenavOpen);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/layout/layout.component.ts